/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import './GovBrTable.css';
import Tooltip from '@material-ui/core/Tooltip';
export function TableBody({ rows, checkbox, path, selected, setSelected }) {
  return (
    <tbody>
      {rows?.map((row, index) => (
        <tr key={index}>
          {checkbox && (
            <>
              <td>
                <Tooltip
                  title={
                    row?.value.disabled ? 'Tarefa de reprocessamento ativa' : ''
                  }
                >
                  <div
                    className="br-checkbox hidden-label"
                    style={{ height: '0px' }}
                  >
                    <input
                      id={row.value.local_id}
                      name={row.value.local_id}
                      type="checkbox"
                      disabled={row?.value?.disabled}
                      onChange={(e) => {
                        setSelected((prevFilter) => ({
                          ...prevFilter,
                          [e.target.name]: !prevFilter[e.target.name],
                        }));
                      }}
                      checked={selected?.[`${row.value.local_id}`]}
                      aria-label="Selecionar tudo"
                    />
                    <label htmlFor={row.value.local_id}>
                      Selecionar todas as linhas
                    </label>
                  </div>
                </Tooltip>
              </td>
            </>
          )}
          {path.map((el) => (
            <td>{row?.value?.[el]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

TableBody.propTypes = {
  columns: PropTypes.array,
};

TableBody.defaultProps = {
  columns: [],
};
